interface EventDetails {
  id: string;
  title: string;
  start_date: string;
  start_time: string;
  end_date?: string;
  end_time?: string;
  location?: string;
  type: string;
  category: string;
  modality: string;
  host_name: string;
  image_url?: string;
  base_url: string;
  host_id: string;
}

export function getEventInvitationEmailTemplate(event: EventDetails) {
  // Generate accept link with auth token if needed
  const acceptUrl = `${event.base_url}/events/${event.id}/manage?from=email&host=${event.host_id}`;
  
  const subject = `Estás invitado a ${event.title}`;
  
  const formattedDate = new Date(event.start_date).toLocaleDateString('es-AR', {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: 'Helvetica Neue', Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }
        .header {
          background-color: #4C66EF;
          padding: 30px 0;
          text-align: center;
        }
        .logo {
          max-width: 150px;
          height: auto;
        }
        .content {
          padding: 30px;
        }
        .event-image {
          width: 100%;
          height: auto;
          border-radius: 6px;
          margin-bottom: 20px;
        }
        h1 {
          color: #333;
          margin-top: 0;
        }
        .event-details {
          background-color: #f5f7fa;
          padding: 20px;
          border-radius: 6px;
          margin: 20px 0;
        }
        .detail-row {
          display: flex;
          margin-bottom: 15px;
        }
        .detail-label {
          width: 120px;
          font-weight: bold;
          color: #666;
        }
        .detail-value {
          flex: 1;
        }
        .cta-button {
          display: inline-block;
          background-color: #4C66EF;
          color: white !important;
          text-decoration: none;
          padding: 14px 30px;
          border-radius: 6px;
          font-weight: bold;
          margin-top: 20px;
          text-align: center;
        }
        .secondary-link {
          display: block;
          margin-top: 15px;
          color: #666;
          text-align: center;
        }
        .footer {
          padding: 20px 30px;
          text-align: center;
          font-size: 12px;
          color: #999;
          border-top: 1px solid #eee;
        }
        @media only screen and (max-width: 500px) {
          .content {
            padding: 20px;
          }
          .detail-row {
            flex-direction: column;
          }
          .detail-label {
            width: 100%;
            margin-bottom: 5px;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          <img src="https://example.com/your-logo.png" alt="Logo" class="logo">
        </div>
        <div class="content">
          <h1>¡Te invitaron a co-organizar un evento!</h1>
          <p>Hola,</p>
          <p>${event.host_name} te invitó a co-organizar el siguiente evento:</p>
          
          ${event.image_url ? `<img src="${event.image_url}" alt="${event.title}" class="event-image">` : ''}
          
          <h2>${event.title}</h2>
          
          <div class="event-details">
            <div class="detail-row">
              <div class="detail-label">Fecha:</div>
              <div class="detail-value">${formattedDate}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Hora:</div>
              <div class="detail-value">${event.start_time}${event.end_time ? ` - ${event.end_time}` : ''}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Lugar:</div>
              <div class="detail-value">${event.location || 'Online'}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Tipo:</div>
              <div class="detail-value">${event.type}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Categoría:</div>
              <div class="detail-value">${event.category}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Modalidad:</div>
              <div class="detail-value">${event.modality}</div>
            </div>
          </div>
          
          <p>Como co-organizador vas a poder gestionar detalles, inscripciones y contribuir al éxito del evento.</p>
          
          <a href="${acceptUrl}" class="cta-button">Aceptar invitación y gestionar evento</a>
          
          <p class="secondary-link">Si tenés preguntas, contactá a ${event.host_name}.</p>
        </div>
        <div class="footer">
          <p>Esta invitación fue enviada por Punta Tech Meetup. Si no querés recibir estos correos, podés desuscribirte.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}